import { Briefcase, Calculator, FileBadge, ShieldCheck, Building2, Users, FileText, Scale, Landmark, Heart, Fingerprint, Globe, Award, Store, HandCoins, FileCheck, Receipt, ClipboardCheck, UserCheck, Building } from 'lucide-react';

export const startupServices = [
  {
    id: 'proprietorship',
    title: 'Proprietorship',
    description: 'Start your business journey with the simplest form of business structure. Ideal for solo entrepreneurs with minimal compliance requirements.',
    icon: 'Briefcase',
    features: ['Quick Setup', 'Minimal Documentation', 'Direct Control', 'Tax Benefits'],
    image: 'https://images.unsplash.com/photo-1542744094-24638eff58bb?w=600'
  },
  {
    id: 'opc',
    title: 'One Person Company',
    description: 'Get limited liability protection as a single owner. Perfect blend of sole proprietorship benefits with corporate structure.',
    icon: 'Building2',
    features: ['Limited Liability', 'Single Member', 'Separate Legal Entity', 'Easy Compliance'],
    image: 'https://images.unsplash.com/photo-1568992687947-868a62a9f521?w=600'
  },
  {
    id: 'pvt-ltd',
    title: 'Private Limited',
    description: 'The most preferred business structure for startups. Attract investors and scale your business with credibility.',
    icon: 'Building',
    features: ['Investor Friendly', 'Limited Liability', 'Perpetual Succession', 'Brand Value'],
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600'
  },
  {
    id: 'llp',
    title: 'Limited Liability Partnership',
    description: 'Combine flexibility of partnership with benefits of limited liability. Best for professional services firms.',
    icon: 'Users',
    features: ['Flexible Structure', 'Lower Compliance', 'Tax Efficient', 'Easy Transfer'],
    image: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=600'
  },
  {
    id: 'section-8',
    title: 'Section 8 Company',
    description: 'Register your non-profit organization with corporate structure. Promote charitable objectives with credibility.',
    icon: 'Heart',
    features: ['Tax Exemptions', 'No Min Capital', 'CSR Funding', 'Government Grants'],
    image: 'https://images.unsplash.com/photo-1593113598332-cd288d649433?w=600'
  },
  {
    id: 'trust-ngo',
    title: 'Trust/NGO Registration',
    description: 'Establish a charitable trust or NGO to serve social causes. Simplified structure for philanthropic activities.',
    icon: 'Landmark',
    features: ['Social Impact', 'Donation Eligible', 'Flexible Operations', 'Tax Benefits'],
    image: 'https://images.unsplash.com/photo-1559027615-cd4628902d4a?w=600'
  }
];

export const gstServices = [
  {
    id: 'gst-registration',
    title: 'GST Registration',
    description: 'Get your business GST compliant quickly. Mandatory for businesses with turnover above threshold limits.',
    icon: 'Receipt',
    features: ['Quick Processing', 'All India Valid', 'Input Tax Credit', 'Legal Compliance'],
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600'
  },
  {
    id: 'gst-cancellation',
    title: 'GST Cancellation',
    description: 'Properly close your GST registration when discontinuing business. Avoid future compliance issues.',
    icon: 'FileText',
    features: ['Proper Closure', 'Final Returns', 'No Future Liability', 'Documentation'],
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600'
  },
  {
    id: 'gst-return',
    title: 'GST Return Filing',
    description: 'Timely filing of GSTR-1, GSTR-3B, and annual returns. Stay compliant and avoid penalties.',
    icon: 'ClipboardCheck',
    features: ['Timely Filing', 'Accurate Reports', 'ITC Optimization', 'Penalty Avoidance'],
    image: 'https://images.unsplash.com/photo-1554224154-26032ffc0d07?w=600'
  },
  {
    id: 'accounting',
    title: 'Accounting Services',
    description: 'Complete bookkeeping and accounting solutions for GST compliance. Focus on business while we handle numbers.',
    icon: 'Calculator',
    features: ['Cloud Accounting', 'Regular Reports', 'Tax Planning', 'Audit Ready'],
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600'
  }
];

export const registrationServices = [
  {
    id: 'startup-india',
    title: 'Startup India',
    description: 'Register under Startup India initiative for tax benefits, funding support, and government schemes.',
    icon: 'Award',
    features: ['Tax Holiday', 'Easy Compliance', 'Funding Access', 'Government Support'],
    image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=600'
  },
  {
    id: 'udyam',
    title: 'Udyam Aadhar',
    description: 'Get MSME registration for government tenders, subsidies, and priority sector lending benefits.',
    icon: 'Fingerprint',
    features: ['Instant Registration', 'Govt Tenders', 'Loan Priority', 'Subsidies'],
    image: 'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=600'
  },
  {
    id: 'iec',
    title: 'Import Export Code',
    description: 'Mandatory code for international trade. Start importing or exporting goods and services from India.',
    icon: 'Globe',
    features: ['Lifetime Validity', 'No Renewal', 'Global Trade', 'Online Process'],
    image: 'https://images.unsplash.com/photo-1494412574643-ff11b0a5c1c3?w=600'
  },
  {
    id: 'trademark',
    title: 'Trademark Registration',
    description: 'Protect your brand identity with trademark registration. Exclusive rights for 10 years, renewable.',
    icon: 'Award',
    features: ['Brand Protection', '10 Year Validity', 'Legal Rights', 'Asset Value'],
    image: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=600'
  },
  {
    id: 'fssai',
    title: 'FSSAI License',
    description: 'Mandatory food safety license for all food businesses. Choose from Basic, State, or Central license.',
    icon: 'FileBadge',
    features: ['Food Safety', 'Consumer Trust', 'Legal Compliance', 'Quality Assurance'],
    image: 'https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=600'
  },
  {
    id: 'shop-establishment',
    title: 'Shop & Establishment',
    description: 'Register your shop or commercial establishment under state-specific labor laws.',
    icon: 'Store',
    features: ['Legal Identity', 'Employee Rights', 'Business Proof', 'Bank Account'],
    image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600'
  },
  {
    id: '12a-80g',
    title: '12A and 80G',
    description: 'Tax exemption registrations for NGOs. Enable donors to claim tax deductions on donations.',
    icon: 'HandCoins',
    features: ['Tax Exemption', 'Donor Benefits', 'CSR Eligible', 'Credibility'],
    image: 'https://images.unsplash.com/photo-1532629345422-7515f3d16bb6?w=600'
  },
  {
    id: 'niti-aayog',
    title: 'NITI Aayog',
    description: 'Register on NGO Darpan portal for unique ID. Required for government funding and CSR projects.',
    icon: 'Landmark',
    features: ['Unique ID', 'Govt Funding', 'CSR Projects', 'Transparency'],
    image: 'https://images.unsplash.com/photo-1577415124269-fc1140a69e91?w=600'
  },
  {
    id: 'psara',
    title: 'PSARA License',
    description: 'Mandatory license for private security agencies. Operate legally with state authorization.',
    icon: 'ShieldCheck',
    features: ['Legal Authority', 'State License', 'Business Credibility', '5 Year Validity'],
    image: 'https://images.unsplash.com/photo-1582139329536-e7284fece509?w=600'
  }
];

export const complianceServices = [
  {
    id: 'itr-filing',
    title: 'Income Tax Filing',
    description: 'Expert assistance for filing ITR for individuals, businesses, and companies. Maximize refunds legally.',
    icon: 'FileCheck',
    features: ['Expert Filing', 'Max Refunds', 'Audit Support', 'All ITR Forms'],
    image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=600'
  },
  {
    id: 'company-compliance',
    title: 'Company Compliance',
    description: 'Annual ROC filings, board meetings, AGM, and all statutory compliances for Private Limited companies.',
    icon: 'ClipboardCheck',
    features: ['ROC Filings', 'Board Minutes', 'AGM Compliance', 'Statutory Registers'],
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600'
  },
  {
    id: 'opc-compliance',
    title: 'OPC Compliance',
    description: 'Simplified annual compliance package for One Person Companies. Stay compliant with minimal effort.',
    icon: 'FileText',
    features: ['Annual Returns', 'Financial Statements', 'Director KYC', 'ROC Filings'],
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600'
  },
  {
    id: 'llp-compliance',
    title: 'LLP Compliance',
    description: 'Complete annual compliance for LLPs including Form 8, Form 11, and income tax returns.',
    icon: 'Scale',
    features: ['Form 8 & 11', 'ITR Filing', 'Partner Changes', 'Annual Statements'],
    image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=600'
  },
  {
    id: 'din-kyc',
    title: 'DIN KYC',
    description: 'Annual director KYC verification mandatory for all company directors. Avoid DIN deactivation.',
    icon: 'UserCheck',
    features: ['Annual Verification', 'Avoid Penalty', 'Quick Process', 'DIN Active'],
    image: 'https://images.unsplash.com/photo-1633265486064-086b219458ec?w=600'
  }
];

export const allServices = [
  ...startupServices,
  ...gstServices,
  ...registrationServices,
  ...complianceServices
];
